import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  group: {
    padding: "0px 0",
  },
}));

const SelectGroup = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.group}>{children}</div>;
};

export default SelectGroup;
